import { PageContainer } from '@/components/Atoms'
import { PageError } from '@/components/PageError'
import { PageLoader } from '@/components/PageLoader'
import { useMassClrRun } from '@/hooks/queries/credit/useMassClr'
import { createFileRoute } from '@tanstack/react-router'
import { MassClrChainReview } from '../-components/MassClrChainReview'
import { massClrRunSearchSchema } from '../-data/runSearch'

export const Route = createFileRoute(
  '/_auth/_modules/credit/credit-limit-reviews/mass/$runId/lines',
)({
  validateSearch: massClrRunSearchSchema,
  component: RouteComponent,
})

/**
 * A run's lines for anyone who can view mass reviews (phase 2 UAT), at any status: the approver's
 * table with both comment columns, and nothing to act with. Reached from the receipt, which is
 * what everyone but the preparer and the pending approver gets on the run page.
 */
function RouteComponent() {
  const params = Route.useParams()
  const search = Route.useSearch()
  const runQuery = useMassClrRun(Number(params.runId))

  if (runQuery.isPending) return <PageLoader />
  if (!runQuery.data) return <PageError />

  return (
    <PageContainer maxWidth="wide">
      <MassClrChainReview run={runQuery.data} readOnly initialBucket={search.bucket} />
    </PageContainer>
  )
}
